
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5H22V19H2V5ZM4 17H20V7H4V17Z" fill="currentColor"></path><path d="M5 8H13V13H5V8Z" fill="currentColor"></path></svg>';export default svg;
    